const actionTypeIdentifier = 'A7D3C9E2-5B41-4F86-9C12-7E3A8D6B2F50';

export const setKyberConfig =
    `SET-KYBER-CONFIG-${actionTypeIdentifier}`;

export const setKyberConfigLoading =
    `SET-KYBER-CONFIG-LOADING-${actionTypeIdentifier}`;

export const setKyberConfigSaved =
    `SET-KYBER-CONFIG-SAVED-${actionTypeIdentifier}`;

export const setKyberChatBotAgentConfig =
    `SET-KYBER-CHATBOT-AGENT-CONFIG-${actionTypeIdentifier}`;

export const setKyberChatBotAgentLoading =
    `SET-KYBER-CHATBOT-AGENT-LOADING-${actionTypeIdentifier}`;

export const setKyberChatBotAgentSaved =
    `SET-KYBER-CHATBOT-AGENT-SAVED-${actionTypeIdentifier}`;

// #region Kyber Proc
export const setKyberProcAgentConfig =
    `SET-KYBER-PROC-AGENT-CONFIG-${actionTypeIdentifier}`;

export const setKyberProcAgentLoading =
    `SET-KYBER-PROC-AGENT-LOADING-${actionTypeIdentifier}`;

export const setKyberProcAgentLoadFailed =
    `SET-KYBER-PROC-AGENT-LOAD-FAILED-${actionTypeIdentifier}`;

export const setKyberProcAgentSaving =
    `SET-KYBER-PROC-AGENT-SAVING-${actionTypeIdentifier}`;

export const setKyberProcAgentSaved =
    `SET-KYBER-PROC-AGENT-SAVED-${actionTypeIdentifier}`;

export const setKyberProcAgentSaveFailed =
    `SET-KYBER-PROC-AGENT-SAVE-FAILED-${actionTypeIdentifier}`;
// #endregion